module.exports = __webpack_public_path__ + "static/img/performance04.c4c7dc45.jpg";